export default __webpack_public_path__ + "static/media/garware-sun-control-film.2d63cab7.webp";